// Base attachment types for notes (original 13 types)
export const ALLOWED_NOTE_ATTACHMENT_TYPES = [
  // Images
  'jpg',
  'jpeg',
  'png',
  'gif',
  'svg',
  'webp',
  // Documents
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
] as const

// Extended attachment types for emails (includes notes + additional types)
export const ALLOWED_EMAIL_ATTACHMENT_TYPES = [
  ...ALLOWED_NOTE_ATTACHMENT_TYPES,
  // Archives
  'zip',
  'rar',
  '7z',
  'tar',
  'gz',
  // Text files
  'txt',
  'csv',
  'json',
  'xml',
  // Media files
  'mp3',
  'mp4',
  'mov',
  'avi',
] as const

// Email attachments always use multipart/form-data (raw binary, no encoding overhead)
export const MAX_EMAIL_ATTACHMENT_SIZE = 25 * 1024 * 1024 // 25MB (Nylas multipart limit)
export const MAX_NOTE_ATTACHMENT_SIZE = 4 * 1024 * 1024 // 4MB
export const EMAIL_ATTACHMENT_WARNING_THRESHOLD = 20 * 1024 * 1024 // 20MB

export type AllowedNoteAttachmentType =
  (typeof ALLOWED_NOTE_ATTACHMENT_TYPES)[number]
export type AllowedEmailAttachmentType =
  (typeof ALLOWED_EMAIL_ATTACHMENT_TYPES)[number]

export const isAllowedAttachmentType = (
  filename: string,
  allowedTypes: readonly string[]
): boolean => {
  const extension = filename.split('.').pop()?.toLowerCase()
  return extension ? allowedTypes.includes(extension) : false
}

export const getFileExtension = (filename: string): string => {
  return filename.split('.').pop()?.toLowerCase() || ''
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
}

export const getAcceptString = (types: readonly string[]): string => {
  return types.map((ext) => `.${ext}`).join(',')
}
